/* eslint-disable react/no-unescaped-entities */
import React, { useRef } from 'react';
import Accordion from '../../atoms/Accordion';
import Container from '../../atoms/Container';
import Styles from './Boleto25Perguntas.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function Boleto25Perguntas() {
  const accRef1 = useRef();
  const accRef2 = useRef();
  const accRef3 = useRef();
  const accRef4 = useRef();
  const accRef5 = useRef();
  const accRef6 = useRef();

  const handleAccChange = (accordion, open) => {
    try {
      if (!open) return;

      switch (accordion) {
        case 1:
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 2:
          accRef1.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 3:
          accRef1.current.close();
          accRef2.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 4:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 5:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef6.current.close();
          break;
        case 6:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          break;

        default:
          break;
      }
    } catch (error) {
      //
    }
  };
  const noop = (ev) => {
    ev.preventDefault();
  };
  return (
    <>
      <section id="perguntas">
        <ContainerHome24>
          <div className="perguntas-contain">
            <picture>
              <source type="image/webp" srcSet="assets/boleto25/img-perguntas.webp" />
              <source type="image/png" srcSet="assets/boleto25/img-perguntas.png" />
              <img
                src="assets/boleto25/img-perguntas.png"
                alt="Mulher sorrindo ao lado de carro e com o celular na mão realizando o pagamento de um boleto de financiamento Santander."
                className="img-perguntas"
              />
            </picture>
            <div className="group-perguntas">
              <h2 className="title-perguntas">Saiba mais sobre boletos Santander</h2>
              <Accordion
                title="Qual o prazo para envio de boleto?"
                accordionRef={accRef1}
                onChange={(open) => {
                  handleAccChange(1, open);
                }}
              >
                <p>
                  Ao contratar um financiamento, o carnê com todos os boletos digitais do seu
                  financiamento será enviado em até 10 dias antes do vencimento da primeira parcela
                  para o e-mail do cadastro.
                </p>
              </Accordion>
              <Accordion
                title="Como funciona o recebimento dos boletos?"
                accordionRef={accRef2}
                onChange={(open) => {
                  handleAccChange(2, open);
                }}
              >
                <p>
                  Caso não tenha recebido o carnê no e-mail do cadastro ou deseja emitir novamente,
                  é possível obter um novo boleto online, através da Área do Cliente. Lembre-se: o
                  serviço está disponível das 05h às 22h.
                </p>
              </Accordion>
              <Accordion
                title="Como emitir a segunda via do boleto?"
                accordionRef={accRef3}
                onChange={(open) => {
                  handleAccChange(3, open);
                }}
              >
                <p>
                  Acesse a Área do Cliente com o seu CPF e senha. Depois, você só precisa selecionar
                  o contrato desejado, clicar em "mostrar parcela", escolhendo uma delas e acessar
                  "consultar parcela" para gerar o boleto.
                </p>
              </Accordion>
              <Accordion
                title="Como saber se o boleto é falso?"
                accordionRef={accRef4}
                onChange={(open) => {
                  handleAccChange(4, open);
                }}
              >
                <p>
                  Analise cuidadosamente o boleto bancário para prevenir fraudes de forma simples,
                  rápida e em poucos passos:
                </p>
                <p>- todo boleto bancário emitido pelo Santander começa com 033;</p>
                <p>
                  - o beneficiário deve ser SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E
                  INVESTIMENTO S.A.;
                </p>
                <p>- confira se o valor é o de sua parcela, desconfie de valores diferentes;</p>
                <p>- confira se consta corretamente o seu nome e CPF no campo pagador.</p>
                <p>
                  <a className="link-accordion-saiba-mais" href="denuncias-e-fraudes.html">
                    Saiba mais em Denúncias e Fraudes
                  </a>
                </p>
              </Accordion>
              <Accordion
                title="Como antecipar minha parcela?"
                accordionRef={accRef5}
                onChange={(open) => {
                  handleAccChange(5, open);
                }}
              >
                <p>
                  Você consegue gerar o boleto com o valor atualizado das parcelas desejadas na Área
                  do Cliente, seguindo o passo a passo:
                </p>
                <p>1. selecione o contrato desejado;</p>
                <p>
                  2. clique em "Antecipar parcelas" e selecione a(s) parcela(s) que deseja
                  antecipar;
                </p>
                <p>
                  3. depois, clique em "Gerar boleto" e será disponibilizado um único boleto com o
                  valor de todas as parcelas selecionadas. Você pode copiar o código de barras ou,
                  se preferir, imprimir o boleto clicando em "Consultar boleto".
                </p>
                <p>
                  Atenção: não será possível antecipar uma parcela agendada para débito de
                  automático, se a mesma estiver dentro do prazo de 5 dias úteis do vencimento. O
                  horário para esta solicitação é das 5h às 22h.
                </p>
              </Accordion>
              <Accordion
                title="Como gerar boleto por WhatsApp?"
                accordionRef={accRef6}
                onChange={(open) => {
                  handleAccChange(6, open);
                }}
              >
                <p>
                  Para gerar boleto pelo Whatsapp, você deve nos mandar um "Oi" no número 11 4004
                  9090. Após ativar seu número, basta selecionar a opção "Gerar boleto" no menu
                  principal e você receberá um resumo da sua parcela com o código de barras. O
                  horário para esta solicitação é das 5h às 22h.
                </p>
                <p>
                  Atenção: o número utilizado para falar conosco deverá ser o mesmo número que
                  consta em seu cadastro, somente assim será possível fazer sua ativação por meio de
                  um código de acesso.
                </p>
              </Accordion>
              <a href="duvidas-frequentes.html" className="btn-outline-red">
                Mostrar todas as perguntas
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25Perguntas;
